import ReactDOMServer from 'react-dom/server';
import React from 'react';
import moment from 'moment-timezone';
import Highcharts from 'highcharts';

import { views } from '../constants/event';
import { doTitle, toggleShowAllButton } from './Common';
import { chartWithGroups } from '../utils/chart/ChartManagementFeatures/showChartFeatures';

const getViewChart = {
  [views.CHART]: 'line',
  [views.COLUMN_CHART]: 'column',
};

const toConversionConfig = ({ name, series }, { timezone }, view) => {
  return {
    time: {
      getTimezoneOffset(timestamp) {
        return -moment.tz(timestamp, timezone).utcOffset();
      },
    },
    exporting: {
      enabled: true,
      contextButton: {
        menuItems: [
          'printChart',
          'separator',
          'downloadPNG',
          'downloadJPEG',
          'downloadPDF',
          'downloadSVG',
        ],
      },
      buttons: {
        Fullscreen: {
          verticalAlign: 'bottom',
          align: 'left',
          text: 'full screen',
          onclick() {
            this.fullscreen.toggle();
          },
        },
        showAll: {
          verticalAlign: 'bottom',
          align: 'left',
          text: doTitle('show all', false),
          onclick() {
            if (this.series.reduce((r, s) => s.visible && r, true)) {
              this.series.forEach((s) => {
                s.setVisible(false, false);
              });
            } else {
              this.series.forEach((s) => {
                s.setVisible(true, false);
              });
            }

            toggleShowAllButton(this);
          },
        },
      },
    },
    groups: [],
    chart: {
      zooming: {
        type: 'x',
      },
      spacingLeft: 0,
      marginLeft: 50,
      events: {
        redraw({ target: chart }) {
          if (chart.series[0]) {
            if (chart.showAll !== chart.series.every((s) => s.visible)) {
              toggleShowAllButton(chart);
            }
          }

          if (!!chart.legend && chart.legend.title !== undefined) {
            chart.legend.title.attr('x', chart.legend.legendWidth / 2);
            chart.legend.title.attr('text-anchor', 'middle');
          }
        },
      },
    },
    yAxis: {
      max: 100,
      title: {
        text: '',
      },
      labels: {
        formatter() {
          return `${this.axis.defaultLabelFormatter.call(this)}%`;
        },
      },
    },
    xAxis: {
      type: 'datetime',
      categories: null,
      min: null,
      max: null,
      events: {
        afterSetExtremes({ min, max }) {
          Highcharts.charts
            .filter((chart) => chartWithGroups(chart, 'zoomSync'))
            .forEach((chart) => chart.xAxis[0].setExtremes(min, max));
        },
      },
    },
    title: {
      text: '',
    },
    legend: {
      title: {
        text: name,
        style: {
          fontSize: '12px',
          fontWeight: 'bold',
        },
      },
      maxHeight: 117,
    },
    series: series.map((s) => ({
      ...s,
      type: getViewChart[view],
    })),
    tooltip: {
      followPointer: view === views.COLUMN_CHART,
      formatter() {
        return ReactDOMServer.renderToStaticMarkup(
          <div>
            <b>{moment.tz(this.x, timezone).format('dddd D MMM YYYY', timezone)}</b>
            <br />
            <b>{this.series.name}</b>
            <br />
            <b>{this.key}</b>
            <br />
          </div>
        );
      },
      zIndex: 10,
    },
  };
};

export default toConversionConfig;
